import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  async open(event) {
    const modalId = event.currentTarget.dataset.modalId
    let dialog = document.getElementById(modalId)

    if (!dialog) {
      const url = event.currentTarget.dataset.modalUrl
      if (!url) return

      const response = await fetch(url, {
        headers: { "X-Requested-With": "XMLHttpRequest" }
      })
      if (!response.ok) return

      const html = await response.text()
      document.body.insertAdjacentHTML("beforeend", html)
      dialog = document.getElementById(modalId)
    }

    if (dialog) {
      dialog.showModal()
      document.body.classList.add("overflow-hidden")
    }
  }

  close() {
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.dialogTarget.close()
    }
  }

  // Fires for every close path — button, backdrop, and the native ESC key.
  dialogTargetConnected(dialog) {
    dialog.addEventListener("close", () => {
      document.body.classList.remove("overflow-hidden")
    })
  }
}
